/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/**
 * Centralized refresh intervals for SNMP switch/router data fetching
 * All intervals are in milliseconds
 */
export const SNMP_REFRESH_INTERVALS = {
  // Device list refresh
  DEVICES_LIST: 30000, // 30 seconds

  // Live status polling
  STATUS: 10000, // 10 seconds

  // Interface list + latest counters
  INTERFACES: 10000, // 10 seconds

  // Traffic history (chart data)
  HISTORY: 30000, // 30 seconds

  // MAC address table
  MAC_TABLE: 60000, // 1 minute
} as const;

export type SNMPRefreshInterval =
  (typeof SNMP_REFRESH_INTERVALS)[keyof typeof SNMP_REFRESH_INTERVALS];
